module.exports = __webpack_public_path__ + "static/media/tlyfe@2x.035413ac.png";